<template>
  <Container v-if="!isLeadLoading" class="container-sm-none">
    <Card class="card-shadow">
      <div class="pl-10 pl-md-0 pr-10 pr-md-0">
        <div class="width-lg">
          <h2 class="heading-1 color-gray-500 weight-medium pt-10 pt-lg-0">
            Online Application for Union Health Insurance
          </h2>
          <p class="body-1 weight-regular pt-10 pb-10">
            Insurance for Yourself, Your Child or the Whole Family
          </p>
          <div class="width-md pt-0 pt-lg-10 pb-20">
            <Button
              class="btn-primary btn-block"
              @click="redirectToNext"
            >
              Submit the Online Application Form
            </Button>
          </div>
          <h3 class="heading-3 weight-medium  pb-10">
            Top benefits for Our Policyholders
          </h3>
        </div>

        <BenefitInformation />

        <div class="width-lg">
          <LandingTextContent class="none block-lg" />
          <LandingTextCollapseContent class="block none-lg" />
        </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import BenefitInformation from '@/components/BenefitInformation/BenefitInformation.vue';
import LandingTextContent from '@/pagesComponents/LandingPageComponents/LandingTextContent.vue';
import LandingTextCollapseContent from '@/pagesComponents/LandingPageComponents/LandingTextCollapseContent.vue';
import routes from '@/mixins/routes';
import GA from '@/mixins/GA';
import enums from '@/mixins/enums';

export default {
  name: 'LandingPage',
  mixins: [routes, GA, enums],
  components: {
    BenefitInformation,
    Button,
    Card,
    Container,
    LandingTextContent,
    LandingTextCollapseContent,
  },
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  computed: {
    isLeadLoading() {
      return this.model.loading === 'LEAD_LOADING';
    },
  },
  methods: {
    redirectToNext() {
      if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
        this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
      }
      this.model.currentPersonStepIndex += 1;
      this.$router.goToStep(this.getNearestNextAvailableStep());
    },
  },
  created() {
    this.model.step = 1;
  },
  mounted() {
    this.funnelStep('Online prihláška do zdravotnej poisťovne Union');
  },
};
</script>
